﻿<!--
  CredibilityTimeline — vertical milestone timeline establishing trust.
  Items use [data-reveal]; the page IntersectionObserver adds .is-visible.
  Hairline rail + filled nodes, no glow. Icon is globally registered.
-->
<template>
  <ol class="tl">
    <li v-for="(m, i) in milestones" :key="i" class="tl-item" data-reveal>
      <div class="tl-marker" aria-hidden="true">
        <span class="tl-node"></span>
      </div>
      <div class="tl-body">
        <div class="tl-year">{{ m.year }}</div>
        <div class="tl-text">{{ m.text }}</div>
      </div>
    </li>
  </ol>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CredibilityTimeline',
  setup() {
    const milestones = [
      { year: '2008', text: 'Scholaro begins evaluating international credentials — the foundation everything else is built on.' },
      { year: '2015', text: 'Practicing member of AICE (Association of International Credential Evaluators).' },
      { year: 'Standard', text: 'Reports accepted by USCIS and recognized by thousands of U.S. universities, each with a verifiable case number.' },
      { year: 'Today', text: 'Over 2 million credentials evaluated across 190+ countries — the pool every applicant is matched against.' },
    ];
    return { milestones };
  },
});
</script>

<style scoped>
.tl { list-style: none; margin: 0; padding: 0; }
.tl-item {
  position: relative;
  display: grid;
  grid-template-columns: 28px 1fr;
  gap: 18px;
  padding-bottom: 36px;
  opacity: 0;
  transform: translateY(14px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.tl-item.is-visible { opacity: 1; transform: none; }
.tl-item:last-child { padding-bottom: 0; }
.tl-marker { position: relative; display: flex; justify-content: center; }
/* connecting rail */
.tl-marker::before {
  content: '';
  position: absolute;
  top: 14px; bottom: -36px; left: 50%;
  width: 1px; transform: translateX(-50%);
  background: rgba(var(--lp-fg), 0.12);
}
.tl-item:last-child .tl-marker::before { display: none; }
.tl-node {
  position: relative; z-index: 1;
  width: 11px; height: 11px; margin-top: 6px;
  border-radius: 9999px;
  background: var(--lp-surface, var(--jb-hero-bg));
  border: 2px solid rgba(var(--jb-primary-rgb), 1);
}
.tl-year {
  font-family: var(--jb-font-mono, ui-monospace, monospace);
  font-size: 0.8125rem; letter-spacing: 0.08em; text-transform: uppercase;
  color: rgba(var(--jb-primary-rgb), 1);
}
.tl-text {
  margin-top: 8px;
  font-size: 0.9375rem; line-height: 1.6;
  color: rgba(var(--lp-fg), 0.7);
  max-width: 56ch;
}
@media (prefers-reduced-motion: reduce) {
  .tl-item { opacity: 1; transform: none; }
}
</style>
